export const GLOBAL = {
  UWQuestionsURL:
    "/uw-questions",
};
